const initScrollToUp = () => {
	const btn = document.querySelector('.js-button-up');
    const footerSub = document.querySelector('.site-footer__sub');

	if (!btn) return;

	btn.addEventListener('click', (e) => {
		e.preventDefault();

		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		})
	})

    function calcBottomPos() {
        if (window.innerWidth > 1023) {
            btn.style.bottom = `${footerSub.offsetHeight}px`
        } else {
            btn.style.bottom = '';
        }
    }

    function checkWindowPos() {
        if (window.scrollY >= window.innerHeight) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    }

    calcBottomPos();
    window.addEventListener('resize', calcBottomPos);

    checkWindowPos();
	window.addEventListener('scroll', checkWindowPos);
}
